var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDpTv(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 286,
    height: 97,
    viewBox: "0 0 286 97",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_19_33)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M282.23 3.32997C250.424 -1.10999 218.156 -1.10999 186.35 3.32997C181.619 33.0294 181.619 63.2905 186.35 92.99C218.156 97.43 250.424 97.43 282.23 92.99C286.961 63.2905 286.961 33.0294 282.23 3.32997ZM245 65.87L233.59 31.1699H240.3L249.19 58.51L261.56 30.51L267.68 32.07L252.33 65.87H245ZM229.34 36.6699H219.78V65.87H213.45V36.6699H203V31.1699H230.38L229.34 36.6699Z",
    fill: "#092A7C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.52 67.4102V70.4102C164.625 68.5112 157.579 67.2097 150.46 66.5201C145.91 66.0701 141.41 65.8501 136.68 65.8501C114.34 65.8501 100.18 70.6701 86.49 75.3201C74 79.5301 62.23 83.5402 43.7701 83.5402C36.1898 83.589 28.6273 82.8008 21.22 81.1901C14.4868 79.6183 7.85205 77.6515 1.35001 75.3L3.05176e-05 74.8501V71.9001L1.11002 72.2802C7.61901 74.6284 14.2605 76.5918 21 78.1602C28.479 79.7908 36.1155 80.589 43.7701 80.5402C62.3901 80.5402 74.25 76.5401 86.7701 72.2301C100.39 67.6001 114.46 62.8101 136.64 62.8101C141.33 62.8101 145.81 63.0301 150.32 63.4701C157.487 64.1707 164.58 65.489 171.52 67.4102Z",
    fill: "#092A7C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.34 26.3701C150.1 26.3701 144.57 32.2901 144.57 41.1101C144.57 47.2801 148.71 53.92 157.8 53.92C166.01 53.92 171.52 47.9901 171.52 39.1801C171.52 33.0001 167.39 26.3701 158.34 26.3701ZM157.8 48.6901C152.8 48.6901 150.54 44.6901 150.54 40.6901C150.54 34.9201 153.38 31.6001 158.34 31.6001C163.3 31.6001 165.55 35.6001 165.55 39.6001C165.55 45.3801 162.71 48.7301 157.8 48.7301V48.6901Z",
    fill: "#092A7C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.13 26.3801C125.566 26.4029 123.06 27.1481 120.9 28.5302L120.6 28.7301L118.39 27.0001H116.6V58.1401C118.77 57.6901 120.76 57.3401 122.6 57.0801V53.8801H123.08C133.08 53.4601 140.26 47.06 140.26 38.67C140.3 31.31 135.41 26.3801 128.13 26.3801ZM123.13 48.9601H122.6V32.9601L122.82 32.8101C124.162 31.939 125.73 31.4801 127.33 31.4901C129.125 31.458 130.859 32.1389 132.153 33.3837C133.446 34.6284 134.193 36.3354 134.23 38.1301C134.23 38.2901 134.23 38.4401 134.23 38.5901C134.23 44.3501 129.81 48.4901 123.18 48.9601H123.13Z",
    fill: "#092A7C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.97 26.5901V53.0601H103.94V32.2401H93.55V53.0601H87.52V27.2301H103.49L109.97 26.5901Z",
    fill: "#092A7C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.16 14.9499L81.08 21.3899L75.16 21.9899L75.82 14.1699L82.16 14.9499Z",
    fill: "#092A7C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.85 26.5801V53.0601H74.85V31.9901H70.94V27.8001L80.85 26.5801Z",
    fill: "#092A7C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.18 26.5801V53.0601H60.15V42.2201H49.23V53.0601H43.2V27.2301H49.23V37.2101H60.15V27.1801L66.18 26.5801Z",
    fill: "#092A7C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.42 47.73V25.12L35.2 19.29H11.3201V24.62H17.8599L8.09988 47.73H4.51004V60.5699H10.51V53.0599H32.0999L30.5401 60.5699H36.5401L39.23 47.73H34.42ZM28.3301 47.73H13.92L24 24.62H28.3101L28.3301 47.73Z",
    fill: "#092A7C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_19_33"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 285.78,
    height: 96.32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDpTv);
export default __webpack_public_path__ + "static/media/dp-tv.969d06fd70ff639832c3221a68819b6f.svg";
export { ForwardRef as ReactComponent };